module.exports = __webpack_public_path__ + "img/1530106862.f6c6d19a.jpg";